import { ArrowRight } from 'lucide-react';

// ✅ Import directo de la imagen local
import finalCtaBg from '@/assets/images/final-cta-bg.jpg';

const FinalCta = () => {
  return (
    <section className="relative overflow-hidden py-28">
      {/* Imagen de fondo */}
      <img
        src={finalCtaBg}
        alt="Instalaciones corporativas limpias y modernas"
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Overlay oscuro */}
      <div className="absolute inset-0 bg-[#0A2540]/85" />

      {/* Contenido */}
      <div className="relative mx-auto max-w-7xl px-5 text-center lg:px-8">
        <h2 className="text-3xl font-bold text-white md:text-5xl">
          LA LIMPIEZA DE TU EMPRESA
          <br />
          TAMBIÉN HABLA DE TI
        </h2>

        <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-blue-100">
          Permítenos ayudarte a mantener tus espacios limpios, seguros y preparados para cada jornada.
        </p>

        <a
          href="#cotizacion"
          className="mt-9 inline-flex items-center gap-2 px-7 py-4 font-bold text-white hover:bg-emerald-700 bg-[#94cf1c] transition-colors"
        >
          SOLICITAR COTIZACIÓN
          <ArrowRight size={18} />
        </a>
      </div>
    </section>
  );
};

export default FinalCta;